// extracted by mini-css-extract-plugin
export default {"headline":"b2wq6b","subtitle":"c2wq6b","arrowIcon":"d2wq6b"};